import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "add-vat-tu-items-form" }
const _hoisted_2 = {
  class: "add-vat-tu-items-form__search",
  "data-autofocus": ""
}
const _hoisted_3 = { class: "text-danger text-xs" }
const _hoisted_4 = { class: "text-danger text-xs" }
const _hoisted_5 = { class: "add-vat-tu-items-form__qty" }
const _hoisted_6 = { class: "add-vat-tu-items-form__action" }
const _hoisted_7 = {
  key: 0,
  class: "text-sm text-gray-600 bg-gray-100 px-2 py-1 rounded"
}
const _hoisted_8 = { class: "mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_QuantityInputCustom = _resolveComponent("QuantityInputCustom")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_AddVatTuTableItems = _resolveComponent("AddVatTuTableItems")!
  const _component_FormModalShell = _resolveComponent("FormModalShell")!
  const _directive_dialog_auto_focus = _resolveDirective("dialog-auto-focus")!

  return (_openBlock(), _createBlock(_component_FormModalShell, {
    "is-display": _ctx.isOpen,
    title: _ctx.titleDisplay,
    size: "xl",
    onClose: _ctx.onClose
  }, {
    footer: _withCtx(() => [
      (_ctx.selectingVatTuItems?.length > 0)
        ? (_openBlock(), _createBlock(_component_ButtonCustom, {
            key: 0,
            "button-type": _ctx.ButtonsType.SAVE,
            "color-type": _ctx.ButtonTypeColors.SUCCESS,
            onClick: _ctx.submit
          }, {
            "button-label": _withCtx(() => [
              _createTextVNode(" Lưu ")
            ]),
            _: 1
          }, 8, ["button-type", "color-type", "onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_ButtonCustom, {
        "button-type": _ctx.ButtonsType.CANCEL,
        "color-type": _ctx.ButtonTypeColors.DANGER,
        onClick: _ctx.onClose
      }, {
        "button-label": _withCtx(() => [
          _createTextVNode(" Đóng ")
        ]),
        _: 1
      }, 8, ["button-type", "color-type", "onClick"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(), _createBlock(_component_el_autocomplete, {
              key: _ctx.vatTuAutocompleteKey,
              modelValue: _ctx.tenVatTu,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tenVatTu) = $event)),
              ref: "vatTuInput",
              class: _normalizeClass(["w-100", { 'vat-tu-input-class-no-result': !_ctx.isVatTuItemsAvailable }]),
              clearable: "",
              placeholder: "Tìm kiếm vật tư",
              "value-key": "ten_vat_tu",
              "trigger-on-focus": _ctx.triggerSearchOnFocus,
              "fetch-suggestions": _ctx.queryVatTu,
              "highlight-first-item": true,
              onClear: _ctx.clearSelectingVatTu,
              onSelect: _ctx.onSelectVatTu,
              onFocus: _ctx.onVatTuSearchFocus,
              onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isSelected = false))
            }, {
              default: _withCtx(({ item }) => [
                _createElementVNode("span", null, [
                  _createElementVNode("strong", null, _toDisplayString(item.ma_vat_tu) + " - ", 1)
                ]),
                _createElementVNode("span", null, _toDisplayString(item.ten_vat_tu), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "class", "trigger-on-focus", "fetch-suggestions", "onClear", "onSelect", "onFocus"])),
            _withDirectives(_createElementVNode("span", _hoisted_3, "Không có dữ liệu", 512), [
              [_vShow, !_ctx.isVatTuItemsAvailable]
            ]),
            _withDirectives(_createElementVNode("span", _hoisted_4, "Vật tư đã chọn", 512), [
              [_vShow, _ctx.isSelected]
            ]),
            _withDirectives(_createElementVNode("span", { class: "text-danger text-xs" }, _toDisplayString(_ctx.quantityErrorMessage), 513), [
              [_vShow, _ctx.hasQuantityError]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_QuantityInputCustom, {
              ref: "soLuongInput",
              modelValue: _ctx.so_luong,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.so_luong) = $event)),
              min: 0.01,
              max: _ctx.quantityInputMax,
              placeholder: "Số lượng",
              "is-disabled": _ctx.vatTuId === 0,
              "class-str": _ctx.hasQuantityError ? 'is-invalid' : '',
              onBlur: _ctx.validateQuantity,
              onChange: _ctx.validateQuantity
            }, null, 8, ["modelValue", "max", "is-disabled", "class-str", "onBlur", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_ButtonCustom, {
              "button-type": _ctx.ButtonsType.ADD,
              "is-disabled": _ctx.isAddButtonDisable,
              "tooltip-message": "Thêm vật tư",
              onClick: _ctx.onAddVatTu
            }, null, 8, ["button-type", "is-disabled", "onClick"]),
            (
              _ctx.useFor === _ctx.AddVatTuItemsFor.PHIEU_XUAT_KHO ||
              _ctx.useFor === _ctx.AddVatTuItemsFor.PHIEU_XUAT_KHO_VAT_TU_THU_HOI
            )
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, " Tối đa: " + _toDisplayString(_ctx.soLuongLimit), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_AddVatTuTableItems, {
            "is-loading": _ctx.isLoading,
            items: _ctx.selectingVatTuItems,
            "show-price-and-total": false,
            onOnDelete: _ctx.onRemoveItem
          }, null, 8, ["is-loading", "items", "onOnDelete"])
        ])
      ])), [
        [_directive_dialog_auto_focus, _ctx.isOpen]
      ])
    ]),
    _: 1
  }, 8, ["is-display", "title", "onClose"]))
}